export const font = {
  primary: 'Heebo, sans-serif',
};
